<template>
  <div id="container">
    <div class="item-box-content" style="padding-bottom:0px;">
      <div class="title-font-style">
        <span>收票信息</span>
      </div>
      <el-form :model="bankformList" class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收票编号：">{{bankformList.invoiceReceiveNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票类型：">{{bankformList.invoiceType}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收票类型：">{{bankformList.bilingType}}</el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="收票公司：">{{bankformList.invoiceReceiveCompany}}</el-form-item>
            <!-- contractCode -->
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票编号：">{{bankformList.invoiceNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请时间：">{{formatData(bankformList.createDate)}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 详情的票据信息 -->
    <div class="item-box-content" v-if="this.$route.query.type ==='3'" style="padding-bottom:0px;">
      <div class="title-font-style">
        <span>票据信息</span>
      </div>
      <el-form
        class="details-line-height"
        style="padding:20px 30px 0 30px"
        :rules="rules"
        :model="bankformList"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收票状态：">{{invoiceState(bankformList.invoiceState)}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票金额：">{{bankformList.amount | amount}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票税额：">{{bankformList.allTaxAmount}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="处理人：">{{bankformList.invoiceState !== 1 ? bankformList.createUser : '--'}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收票时间：">{{bankformList.invoiceReceiveDate | formatData}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="item-box-content" v-if="this.$route.query.type !=='3' " style="padding-bottom:20px;">
      <div class="title-font-style">
        <span>票据信息</span>
      </div>
      <el-form
        class="details-line-height"
        style="padding:20px 30px 0 30px"
        :rules="rules"
        :model="bankformList"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收票状态：">{{invoiceState(bankformList.invoiceState)}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票金额：">{{bankformList.amount | amount}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票税额：">{{bankformList.allTaxAmount}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="15">
            <el-form-item prop="state" label="处理方案：">
              <el-radio v-model="redio" label="2">已收票</el-radio>
              <el-radio v-model="redio" label="3">拒收</el-radio>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form ref="numberValidateForm" :model="returnMark" :rules="numberRule">
              <el-form-item
                prop="mark"
                label="被拒原因："
                v-show="redio==='3'"
              >
                <el-input
                  v-model="returnMark.mark"
                  maxlength="100"
                  type="textarea"
                  :rows="3"
                  style="width:90%"
                  placeholder="请填写核审不通过原因"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-button type="primary" letter-spacing @click="submitBtn()">提交</el-button>
      </el-form>
    </div>

    <!-- 产品详情---------------------------------------------------------- -->
    <div class="item-box-content" v-if="bankformList.bilingType !== '罚没金付款'">
      <div style="display: flex;justify-content: space-between">
        <div class="title-font-style">
          <span>产品详情</span>
        </div>
        <el-button
          type="primary"
          plain
          @click="financeExportReceiptApplication"
          style="font-size: 14px;padding:6px 10px;"
          size="small">
          导出清单
        </el-button>
      </div>
      <el-table
        style="margin-top:20px"
        border
        ref="tableRef"
        :data="tableList"
        max-height="378"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column label="采购合同编号" prop="pcbNumber">
  <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="detail(scope.row)"
            >{{ scope.row.pcbNumber}}</div>
          </template>
        </el-table-column>
        <el-table-column label="供应商合同编号" prop="supplierContractNumber"></el-table-column>
        <el-table-column label="产品名称" prop="proName"></el-table-column>
        <el-table-column label="型号" prop="proModel">
 <template slot-scope="scope">
                    <div
                      class="approval line-limit-length"
                      @click="detailModel(scope.row)"
                    >{{ scope.row.proModel }}</div>
                  </template>
        </el-table-column>
        <el-table-column label="订货号" prop="proOrdernum"></el-table-column>
        <el-table-column label="单位" prop="proUnit"></el-table-column>
        <el-table-column label="数量" prop="quantity"></el-table-column>
        <el-table-column label="实付单价" width="100px" prop="purchasePrice">
          <template v-slot="{ row }">{{row.purchasePrice | toFixed}}</template>
        </el-table-column>
        <el-table-column label="实付总额" width="100px" prop="cbRate">
          <template v-slot="{ row }">{{row.totalMoney | toFixed}}</template>
        </el-table-column>
        <el-table-column label="税率" prop="taxRate">
          <template v-slot="{ row }">{{row.taxRate | toPercentFormat}}</template>
        </el-table-column>
        <el-table-column label="税额" prop="taxAmount"></el-table-column>
      </el-table>
    </div>
    <operation-log-and-flow :flowLabel="flowLabel" :typesel="typesel" :id="id"></operation-log-and-flow>
    <!-- 弹框 -->
    <el-dialog title="确认提交" :visible.sync="dialogVisible" width="480px">
      <div style="padding: 0 30px;">确定提交处理结果？</div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureBtn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 提交的弹框 -->
    <el-dialog title="确认提交" :visible.sync="dialogVisible" width="480px">
      <div style="padding: 0 30px;">确定提交处理结果？</div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureBtn()">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  financeExportReceiptApplication,
  queryPurchaseContractInvociesListVo,
  updateStateByPciId
} from '@/api/fiance/fianceManage'
import operationLogAndFlow from '@/components/OperationLog/operationLogAndFlow'
import { formatData } from '@/util/filterCommon'
import { isEmpty } from 'loadsh'
import { downLoadFileBlob } from '@/util/tool'

export default {
  components: {
    'operation-log-and-flow': operationLogAndFlow
  },
  data () {
    return {
      activeName: '',
      // id:this.$route.query.id,
      dialogVisible: false,
      flowLabel: '收票流程',
      typesel: 'purchaseInvoice',
      id: '',
      bankformList: {
        confirmState: ''
      },
      textarea: '',
      returnMark: {
        mark: ''
      },
      redio: '2',
      type: '',
      params: {},
      rules: {
        mark: {
          required: true,
          message: '必填'
        }
      },
      tableList: [],
      numberRule: {
        mark: [
          {
            required: true,
            message: '请输入被拒原因',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  filters: {
    amount (amount) {
      if (!amount) {
        return ''
      }
      return amount.toFixed(2)
    }
  },
  mounted () {
    this.id = this.$route.query.id
    queryPurchaseContractInvociesListVo(this.$route.query.invoiceReceiveNumber)
      .then((res) => {
        if (res.data.code === 200) {
          this.bankformList = res.data.obj
          this.tableList = res.data.obj.purchaseContractInvociesVoList
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    // 采购合同编号跳转页面
    detail(row) {
      this.$router.push({
        name: 'contractDetails',
        query: { type: '已履行', pcbId: row.pcbId }
      })
    },
    // 型号跳转产品详情页
    detailModel(row) {
      this.$router.push({
        path: '/product/productManage/productDetails',
        query: { id: row.proId }
      })
    },
    formatData,
    financeExportReceiptApplication () {
      financeExportReceiptApplication({
        financeTicketUrl: this.$store.state.financeExportReceiptApplication,
        invoiceReceiveNumber: this.$route.query.invoiceReceiveNumber
      }).then(res => {
        downLoadFileBlob(this, res)
      })
    },
    invoiceState (invoiceState) {
      if (invoiceState === 1) {
        return '未收票待审批'
      } else if (invoiceState === 2) {
        return '已收票'
      } else if (invoiceState === 3) {
        return '已退票'
      } else if (invoiceState === 4) {
        return '拒收'
      }
    },
    // 提交
    submitBtn () {
      if (this.redio !== '3') {
        this.dialogVisible = true
        return
      }
      this.$refs.numberValidateForm.validate(vailde => {
        if (vailde) {
          this.dialogVisible = true
        }
      })
    },
    // 确认
    sureBtn (row) {
      const paramsbank = [{
        id: this.$route.query.id,
        mark: this.returnMark.mark,
        megerCode: this.$route.query.invoiceReceiveNumber
      }]
      updateStateByPciId(paramsbank, null, this.redio)
        .then((res) => {
          if (res.data.code === 200) {
            this.bankformList = res.data.obj
            this.$message({
              showClose: true,
              message: '提交成功',
              type: 'success'
            })
            this.$router.push('/finance/financeManage/financeChecksManage')
          }
        })
        .catch((err) => {
          console.log(err)
        })

      this.dialogVisible = false
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      if (isEmpty('a')) {
      }
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
  .pay {
    padding-top: 8px;
    font-weight: bold;
  }

  .look {
    color: blue;
    padding-left: 20px;
  }

  ::v-deep .el-form-item__error {
    padding-left: 80px;
    padding-top: 10px;
  }
</style>
